/**
 * @typedef {Object} HNode
 * @property {string} hNodeType
 * @property {HNode[]} [children]
 *
 * @param {HNode[]} hNodes
 * @param {string} hNodeType
 */
module.exports = function findHNode(hNodes, hNodeType) {
    if (!Array.isArray(hNodes)) {
        hNodes = [hNodes];
    }
    for (const hNode of hNodes) {
        if (hNode.hNodeType === hNodeType) {
            return hNode;
        }
        if (hNode.children) {
            let found = findHNode(hNode.children, hNodeType);
            if (found) {
                return found;
            }
        }
    }
    return null;
};
